module.exports = __webpack_public_path__ + "media/images/icon/close-gray-f52817767b295c35567ce2d4d4ff1358.png";